import { ResponsiveBar } from "@nivo/bar";
import ChartCard from "../../../../shared/charts/ChartCard";
import { NIVO_DARK_THEME } from "./HeadcountChart";

/**
 * Legacy Waterfall — Nivo grouped bar. Revenue + (costs as negative)
 * per month, same shape the original SVG used. Kept behind
 * fin_chart_waterfall_legacy so admins can opt-in per role.
 */
export default function WaterfallChart({ data, canSee }) {
  if (!canSee) return null;
  return (
    <ChartCard
      title="Revenue vs Costs — Waterfall (legacy)"
      subtitle="Positive = revenue, negative = cost; kept for continuity"
    >
      <div style={{ height: 320 }}>
        <ResponsiveBar
          data={data}
          keys={["Revenue", "Cost"]}
          indexBy="month"
          margin={{ top: 12, right: 28, bottom: 36, left: 54 }}
          padding={0.3}
          groupMode="grouped"
          colors={({ id }) => (id === "Revenue" ? "#10c981" : "#ef4444")}
          axisBottom={{ tickSize: 0, tickPadding: 6 }}
          axisLeft={{ tickSize: 0, tickPadding: 6, format: (v) => `${(v / 1000).toFixed(0)}K` }}
          labelSkipWidth={14}
          labelSkipHeight={14}
          enableLabel={false}
          theme={NIVO_DARK_THEME}
          animate={false}
        />
      </div>
    </ChartCard>
  );
}
